<template>
  <div id="app">
    <!-- 公共头部导航 -->
    <!-- <div class="header-nav">
      <h1>
        <a href="/" class="tx_indent css_sp">迷你世界</a>
      </h1>
      <div id="main-nav" style="height: 85px;">
        <div class="wrap" id="navWrap">
          <ul class="clearfix">
            <li>
              <a target="_blank" href="https://www.mini1.cn/news_list">新闻资讯</a>
              <ul>
                <li>
                  <a target="_blank" href="https://www.mini1.cn/news_list/news.html">官方新闻</a>
                </li>

                <li>
                  <a target="_blank" href="https://gy.mini1.cn/">公益活动</a>
                </li>

                <li>
                  <a target="_blank" href="https://www.mini1.cn/news_list/announcement.html">游戏公告</a>
                </li>

                <li>
                  <a target="_blank" href="https://www.mini1.cn/news_list/activity.html">游戏活动</a>
                </li>
              </ul>
            </li>

            <li>
              <a target="_blank" href="https://www.mini1.cn/strategy_list">游戏攻略</a>
              <ul>
                <li>
                  <a target="_blank" href="https://www.mini1.cn/strategy_list/captain.html">队长专栏</a>
                </li>

                <li>
                  <a target="_blank" href="https://www.mini1.cn/strategy_list/raiders.html">玩家攻略</a>
                </li>

                <li>
                  <a target="_blank" href="https://developers.mini1.cn/wiki/">开发者wiki</a>
                </li>
              </ul>
            </li>

            <li>
              <a target="_blank" href="https://www.mini1.cn/video_list">游戏视频</a>
              <ul>
                <li>
                  <a target="_blank" href="https://www.mini1.cn/video_list/recommendvideo.html">推荐视频</a>
                </li>

                <li>
                  <a target="_blank" href="https://www.mini1.cn/video_list/building.html">建筑视频</a>
                </li>

                <li>
                  <a target="_blank" href="https://www.mini1.cn/video_list/survive.html">生存视频</a>
                </li>

                <li>
                  <a target="_blank" href="https://www.mini1.cn/video_list/entertainment.html">娱乐视频</a>
                </li>

                <li>
                  <a target="_blank" href="https://www.mini1.cn/video_list/other.html">其他视频</a>
                </li>
              </ul>
            </li>

            <li>
              <a target="_blank" href="https://www.mini1.cn/picture_list">图音专区</a>
              <ul>
                <li>
                  <a target="_blank" href="https://www.mini1.cn/picture_list/fanpaint.html">同人绘</a>
                </li>

                <li>
                  <a target="_blank" href="https://www.mini1.cn/picture_list/fanvedio.html">同人视频</a>
                </li>

                <li>
                  <a
                    target="_blank"
                    href="https://www.mini1.cn/picture_list/computerwallpaper.html"
                  >手机壁纸</a>
                </li>

                <li>
                  <a
                    target="_blank"
                    href="https://www.mini1.cn/picture_list/phonewallpaper.html"
                  >电脑壁纸</a>
                </li>

                <li>
                  <a target="_blank" href="http://v.douyin.com/M4GPqH/">抖音小视频</a>
                </li>
              </ul>
            </li>

            <li>
              <a target="_blank" href="https://www.mini1.cn/special_center">专题活动</a>
              <ul>
                <li>
                  <a target="_blank" href="https://mnxgc.mini1.cn/">迷你星工场</a>
                </li>

                <li>
                  <a target="_blank" href="https://www.mini1.cn/xszl">新手专题</a>
                </li>

                <li>
                  <a target="_blank" href="https://qmcz.mini1.cn/">全民创造节</a>
                </li>

                <li>
                  <a target="_blank" href="https://www.mini1.cn/mobile/sunny/index.html">阳光计划</a>
                </li>

                <li>
                  <a target="_blank" href="https://activities.mini1.cn/fe/starPlan/">星启计划</a>
                </li>
              </ul>
            </li>

            <li>
              <a target="_blank" href="https://www.mini1.cn/welfare_center">福利中心</a>
              <ul>
                <li>
                  <a target="_blank" href="https://www.mini1.cn/welfare_center/gift.html">独家礼包</a>
                </li>

                <li>
                  <a
                    target="_blank"
                    href="https://shop339208323.taobao.com/index.htm?spm=2013.1.w5002-21493451414.2.712160aeenQuj1"
                  >游戏周边</a>
                </li>
              </ul>
            </li>

            <li>
              <a target="_blank" href="https://dwz.cn/GsYdUoB2">官方阵营</a>
              <ul>
                <li>
                  <a target="_blank" href="https://dwz.cn/GsYdUoB2">官方微信</a>
                </li>

                <li>
                  <a target="_blank" href="https://weibo.com/u/6096473252">官方微博</a>
                </li>

                <li>
                  <a target="_blank" href="https://www.miniworldbox.com/">官方社区</a>
                </li>

                <li>
                  <a target="_blank" href="https://www.mini1.cn/article/20190527/840.html">官方客服</a>
                </li>

                <li>
                  <a
                    target="_blank"
                    href="https://www.toutiao.com/c/user/97357321987/#mid=1610294451204099"
                  >微头条</a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="header_top"></div> -->
    <loginPage></loginPage>
    <!-- 公共底部-->
    <!-- <div class="common-footer">
      <i class="intersperse"></i>
      <div class="footer-wrap">
        <div class="top">
          <div class="miniwan fl css_sp"></div>
          <div class="minishijie fl css_sp"></div>
        </div>
        <div class="bot clearfix">
          <div class="fl leftfont">
            <a href="javascript:;">加入家长监护工程 &gt; &gt;</a>
            <strong>本游戏适合全年龄段玩家</strong>
            <p>抵制不良游戏，拒绝盗版游戏。注意自我保护，谨防受骗上当。适度游戏益脑， 沉迷游戏伤身。合理安排时间，享受健康生活。</p>
            <p>Copyright 2015-2019 深圳市迷你玩科技有限公司 All Rights Reserved.</p>
          </div>
          <div class="fr rightfont" style="padding-top: 25px;">
            <p>
              <a target="_blank" href="https://www.mini1.cn/article/20190527/835.html">未成年人充值公告</a> |
              <a target="_blank" href="https://www.mini1.cn/article/20181011/537.html">不良内容管理办法</a> |
              <a target="_blank" href="https://www.mini1.cn/article/20181102/564.html">护眼小指南</a> |
              <a target="_blank" href="https://www.mini1.cn/article/20190527/839.html">游戏许可及服务协议</a> |
              <a target="_blank" href="https://www.mini1.cn/article/20190527/837.html">隐私政策</a>
            </p>
            <p>
              <a target="_blank" href="https://www.mini1.cn/article/20190527/836.html">关于我们</a> |
              <a target="_blank" href="https://www.mini1.cn/article/20190527/840.html">客服电话</a> |
              <a target="_blank" href="https://www.mini1.cn/guardianship.html">家长监护</a>
            </p>
            <p>
              <span>软著2016SR366060</span> |
              <span>增值电信业务经营许可证： 粤B2-20160622</span> |
              <span>
                <a target="_blank" href="http://beian.miit.gov.cn/">粤ICP备15114487号-1</a>
              </span>
            </p>
            <p>
              <span>文网游备字〔2017〕Ｃ-CSG 0005 号</span> |
              <span>新广出审[2017]5896号</span> |
              <span>ISBN 978-7-7979-9367-8</span>
            </p>
            <p>
              <span>
                <a
                  target="_blank"
                  href="https://www.mini1.cn/article/20190527/841.html"
                >《网络文化经营许可证》粤网文[2016]1349-302号</a>
              </span> |
              <span>粤公网备案 : 44030502000994</span>
            </p>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import loginPage from "../src/view/loginPage";
export default {
  name: "app",
  components: {
    loginPage
  },
  // mounted() {
  //   $("#navWrap").hover(
  //     function() {
  //       $("#main-nav").css({
  //         height: $("#navWrap").height()
  //       });
  //     },
  //     function() {
  //       $("#main-nav").css({
  //         height: 85
  //       });
  //     }
  //   );
  // },
  methods: {}
};
</script>
<style lang="scss" scoped>
#app{
  .header_top{
    background: #fff;
    height: 95px;
    width: 100%;
  }
}
</style>

